import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';

import { TimeOffBlockType } from '../types';
import { PlannerTimeoffResponse } from '../types/dto/response/planner-timeoff-response';

dayjs.extend(minMax);

export const mapTimeOffFromResponse = (response: PlannerTimeoffResponse): TimeOffBlockType => {
  const totalMinutes = response.days.reduce((sum, day) => sum + day.minutes, 0);

  // Derive the span from the days array (min/max date) rather than the
  // response's startDate/endDate. The backend clips startDate/endDate to the
  // queried page range, so a long time-off spanning multiple horizontal pages
  // would otherwise only render across the first page's clipped range. The
  // days[] array is the authoritative source and is merged across pages by
  // mergeTimeOffs, which keeps startDate/endDate in sync the same way.
  const dayDates = response.days.map(d => dayjs(d.date));
  const startDate = dayDates.length > 0 ? dayjs.min(dayDates)! : dayjs(response.startDate);
  const endDate = dayDates.length > 0 ? dayjs.max(dayDates)! : dayjs(response.endDate);

  return {
    id: response.id,
    originalTimeOff: response,
    title: response.timeOffTypeName,
    startDate,
    endDate,
    status: response.status,
    totalMinutes,
  };
};

export const mapTimeOffsFromPlannerResponse = (
  responses: PlannerTimeoffResponse[]
): TimeOffBlockType[] => responses.map(mapTimeOffFromResponse);
